module.exports = __webpack_public_path__ + "img/安全培训.079b3c10.png";